import { TextField } from '@humanforce/mango-ui-react';

// Shared "Reason for backdated change" field shown by every effective-dated form (Person Details,
// Contacts, Address, Worker Form) when the chosen effective date is retroactive. Centralised so the
// label, requiredness and error treatment stay identical across all of them.
interface RetroactiveReasonFieldProps {
  show: boolean;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

export const RetroactiveReasonField = ({ show, value, onChange, error, disabled }: RetroactiveReasonFieldProps) => {
  if (!show) return null;
  return (
    <TextField label="Reason for backdated change" required value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)} status={error ? 'critical' : undefined} statusText={error} />
  );
};
